import { Routes } from '@angular/router';
import { Typology } from '@bcef/ia-shared';

import { TypologyGuard } from '@features/parrainage-filleul/guards/typology.guard';
import { SponsorshipResolver } from '@features/parrainage-filleul/resolvers/sponsorship.resolver';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./features/parrainage-filleul/pages/mbpart-mbpro/components/landing-page/landing-page.component').then(
        (m) => m.LandingPageComponent,
      ),
    canMatch: [TypologyGuard],
    data: {
      typology: [Typology.PART, Typology.PRO, Typology.BPF],
    },
    resolve: {
      resolver: SponsorshipResolver,
    },
  },
  {
    path: '',
    loadComponent: () =>
      import('./features/parrainage-filleul/pages/nhbpart/components/landing-page/landing-page.component').then(
        (m) => m.LandingPageComponent,
      ),
    canMatch: [TypologyGuard],
    data: {
      typology: [Typology.NHB, Typology.HB],
    },
    resolve: {
      resolver: SponsorshipResolver,
    },
  },
  {
    path: '',
    loadComponent: () =>
      import('./features/parrainage-filleul/pages/nhbpro/components/landing-page/landing-page.component').then(
        (m) => m.LandingPageComponent,
      ),
    canMatch: [TypologyGuard],
    data: {
      typology: [Typology.NHBPRO, Typology.HBPRO],
    },
    resolve: {
      resolver: SponsorshipResolver,
    },
  },
  {
    path: 'error',
    loadComponent: () =>
      import('./shared/components/error-page/error-page.component').then(
        (m) => m.ErrorPageComponent,
      ),
  },
  {
    path: 'expired-page',
    loadComponent: () =>
      import('./shared/components/expired-offer/expired-offer.component').then(
        (m) => m.ExpiredOfferComponent,
      ),
  },
  {
    path: 'on-site-acknowledgment',
    loadComponent: () =>
      import('./features/parrainage-filleul/pages/acknowledgment/on-site-acknowledgment/on-site-acknowledgment.component').then(
        (m) => m.OnSiteAcknowledgmentComponent,
      ),
  },
  {
    path: 'digital-acknowledgment',
    loadComponent: () =>
      import('./features/parrainage-filleul/pages/acknowledgment/digital-acknowledgment/digital-acknowledgment.component').then(
        (m) => m.DigitalAcknowledgmentComponent,
      ),
  },
  {
    path: 'digital-acknowledgment-qrcode',
    loadComponent: () =>
      import('./features/parrainage-filleul/pages/acknowledgment/digital-acknowledgment-qrcode/digital-acknowledgment-qrcode.component').then(
        (m) => m.DigitalAcknowledgmentQrCodeComponent,
      ),
  },
];
